enum HealthAppStatus {
  Completed = "completed",
  Pending = "pending",
  Active = "active",
}

const LANDING_PAGE = {
  pageTitle: "Health insurance pricing",
  backToDashboard: "Back to Dashboard",
  backToBenefits: "Back to Benefits",
  informationBox:
    "To get your pricing, the health insurance providers we work with require that Justworks collects this information. It helps them understand who will be getting access to insurance.",
};

const STEPS_DATA = {
  PRE_QUALIFY: {
    stepTitle: "Let's make sure you qualify",
    iconBackground: "var(--base-color-purple-300)",
    redirectPath: "pre-qualification",
    steps: [],
    getStatus(applicationStep: number) {
      if (applicationStep < 4) {
        return HealthAppStatus.Active;
      }

      return HealthAppStatus.Completed;
    },
  },
  CURRENT_INFORMATION: {
    stepTitle: "Census & current information",
    iconBackground: "var(--base-color-blue-200)",
    redirectPath: "census-and-current-information",
    getStatus(applicationStep: number) {
      if (applicationStep < 4) {
        return HealthAppStatus.Pending;
      }

      if (applicationStep >= 4 && applicationStep < 8) {
        return HealthAppStatus.Active;
      }

      return HealthAppStatus.Completed;
    },
  },
  REVIEW_AND_SUBMIT: {
    stepTitle: "Review & submit",
    iconBackground: "var(--base-color-green-300)",
    redirectPath: "health-application-status",
    buttonText: "Submit",
    getStatus(applicationStep: number) {
      if (applicationStep < 8) {
        return HealthAppStatus.Pending;
      }

      if (applicationStep === 8) {
        return HealthAppStatus.Active;
      }

      return HealthAppStatus.Completed;
    },
  },
};

const BACK_TO_DASHBOARD = "Back to Dashboard";

export { STEPS_DATA, LANDING_PAGE, BACK_TO_DASHBOARD, HealthAppStatus };
